import { render, staticRenderFns } from "./ConsignacaoList.vue?vue&type=template&id=284f3291&scoped=true&"
import script from "./ConsignacaoList.vue?vue&type=script&lang=js&"
export * from "./ConsignacaoList.vue?vue&type=script&lang=js&"
import style0 from "./ConsignacaoList.vue?vue&type=style&index=0&id=284f3291&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284f3291",
  null
  
)

export default component.exports